export enum LangCode {
  da = 'da',
  en = 'en',
  de = 'de',
  nl = 'nl',
  fi = 'fi',
  se = 'se',
  no = 'no',
  fr = 'fr',
  es = 'es',
  it = 'it',
  pt = 'pt',
  tr = 'tr',
  is = 'is',
}

export const LangMap = new Map([
  [LangCode.da, { pattern: /^da/i, label: 'Dansk', img: '/images/flag_dk.png' }],
  [LangCode.en, { pattern: /^en/i, label: 'English', img: '/images/flag_en.png' }],
  [LangCode.de, { pattern: /^de/i, label: 'Deutsch', img: '/images/flag_dk.png' }],
  [LangCode.nl, { pattern: /^nl/i, label: 'Nederlands', img: '/images/flag_dk.png' }],
  [LangCode.fi, { pattern: /^fi/i, label: 'Suomi', img: '/images/flag_dk.png' }],
  [LangCode.se, { pattern: /^sv/i, label: 'Svenska', img: '/images/flag_dk.png' }],
  [LangCode.no, { pattern: /^no/i, label: 'Norsk', img: '/images/flag_dk.png' }],
  [LangCode.fr, { pattern: /^fr/i, label: 'Français', img: '/images/flag_dk.png' }],
  [LangCode.es, { pattern: /^es/i, label: 'Español', img: '/images/flag_dk.png' }],
  [LangCode.it, { pattern: /^it/i, label: 'Italiano', img: '/images/flag_dk.png' }],
  [LangCode.pt, { pattern: /^pt/i, label: 'Português', img: '/images/flag_dk.png' }],
  [LangCode.tr, { pattern: /^tr/i, label: 'Türkçe', img: '/images/flag_dk.png' }],
  [LangCode.is, { pattern: /^is/i, label: 'Íslenska', img: '/images/flag_dk.png' }],
] as const);
